import UniData from '@/common/classes/UniData'
import UniDataTable from '@/common/classes/UniDataTable'
import {toRaw} from "vue";

export class TypeSerializer {
  static serialize(item: any): any {
    const rawValue = toRaw(item)
    if (rawValue === null || rawValue === undefined) {
      return {
        type: 'String',
        value: null
      }
    }

    // Типы в сериализации в итоге могут быть только UniData, UniDataTable - смотреть десериализатор
    // Сериализация - десериализация в какой момент проводится? хранение в сторе - в каком виде

    if (typeof rawValue === 'object' && rawValue !== null && !Array.isArray(rawValue) && 'type' in rawValue && 'value' in rawValue) {
      return {
        type: rawValue.type,
        value: toRaw(rawValue.value)
      }
    }

    if (typeof rawValue === 'boolean') {
      return {
        type: 'Boolean',
        value: rawValue
      }
    } else if (typeof rawValue === 'number') {
      return {
        type: Number.isInteger(rawValue) ? 'Long' : 'Double',
        value: rawValue
      }
    } else if (typeof rawValue === 'string') {
      return {
        type: 'String',
        value: rawValue
      }
    } else if (Array.isArray(rawValue)) {
      return {
        type: 'Array',
        value: rawValue
      }
    } else if (
      rawValue instanceof UniDataTable ||
      (typeof rawValue === 'object' &&
        rawValue !== null &&
        Array.isArray((rawValue as { rows?: unknown[] }).rows))
    ) {
      return {
        type: 'UniDataTable',
        value: rawValue
      }
    } else if (typeof rawValue === 'object' && rawValue !== null) {
      return {
        type: 'Object',
        value: rawValue
      }
    } else {
      return {
        type: 'String',
        value: String(rawValue)
      }
    }
  }

  static deserialize(item: {value: any, type?: string}): any {
    if (!item || typeof item !== 'object' || !('type' in item) || !('value' in item)) {
      return item
    }

    const itemType = typeof item.type === 'string' ? item.type : ''
    const itemValue = item.value

    switch (itemType) {
      case 'Boolean':
        return itemValue === true || itemValue === 'true'
      case 'MapEntry':
        return itemValue && typeof itemValue === 'object'
          ? {
            name: itemValue.name,
            value: itemValue.value,
          }
          : itemValue
      case 'Date':
      case 'Timestamp':
      case 'TimezonelessDate':
        return itemValue == null ? itemValue : new Date(itemValue)
      case 'Integer':
      case 'Long':
      case 'Double':
      case 'Number':
      case 'BigDecimal':
      case 'base64Binary':
        return itemValue
      case 'intArray':
      case 'floatArray':
      case 'stringArray':
        return Array.isArray(itemValue) ? [...itemValue] : itemValue
      case 'genericArray':
        return Array.isArray(itemValue)
          ? itemValue.map((entry) => TypeSerializer.deserialize(entry))
          : itemValue
      case 'UniData':
      case 'ru.esoft.Common.UniData.UniData':
        return new UniData(itemValue?.fields?.fields ?? itemValue?.fields ?? itemValue)
      case 'UniDataTableFields':
      case 'ru.esoft.Common.UniData.UniDataTableFields':
        return new UniData(itemValue?.fields ?? itemValue)
      case 'UniDataTable':
      case 'ru.esoft.Common.UniData.UniDataTable':
        return new UniDataTable(itemValue)
      case 'String':
        return itemValue == null ? itemValue : String(itemValue)
      default:
        return itemValue
    }
  }

  static deserializeLegacy(item: any, itemType: string): any {
    switch (itemType) {
      case 'ru.esoft.Common.UniData.UniDataTable':
        return new UniDataTable(item)
      default:
        return item
    }
  }
}
